
/* THE ELYSIAN — PREMIUM CART UPSELL
   Dawn 16.1.0
   Random 4 products on every cart opening
*/

(function () {
  'use strict';

  const DRAWER = 'cart-drawer';
  const RAIL = '.elysian-upsell-track';
  const CARD = '.ely-upsell__card';

  let previousSelection = '';

  function randomizeUpsells() {
    const drawer = document.querySelector(DRAWER);
    const rail = drawer?.querySelector(RAIL);
    if (!rail) return;

    const cards = Array.from(rail.children)
      .filter(card => card.matches(CARD));

    if (!cards.length) return;

    // Clear any hidden state from previous scripts.
    cards.forEach(card => {
      card.hidden = false;
    });

    // Randomly shuffle the cards.
    let shuffled;
    let selection;
    let attempts = 0;

    do {
      shuffled = [...cards];

      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] =
          [shuffled[j], shuffled[i]];
      }

      selection = shuffled
        .slice(0, 4)
        .map(card => card.querySelector('a')?.href || '')
        .join('|');

      attempts++;
    } while (
      cards.length > 4 &&
      selection === previousSelection &&
      attempts < 10
    );

    previousSelection = selection;

    // Move selected cards to the front.
    const fragment = document.createDocumentFragment();

    shuffled.forEach((card, index) => {
      card.hidden = index >= 4;
      fragment.appendChild(card);
    });

    rail.appendChild(fragment);
    rail.scrollLeft = 0;
  }

  // Handle Dawn's cart opening and AJAX re-rendering.
  const observer = new MutationObserver(() => {
    const drawer = document.querySelector(DRAWER);
    if (!drawer) return;

    const isOpen = drawer.classList.contains('active');
    const rail = drawer.querySelector(RAIL);

    if (!isOpen) {
      drawer.dataset.elyUpsellOpen = 'false';
      return;
    }

    if (!rail) return;

    if (
      drawer.dataset.elyUpsellOpen !== 'true' ||
      drawer._elyLastRail !== rail
    ) {
      drawer.dataset.elyUpsellOpen = 'true';
      drawer._elyLastRail = rail;
      randomizeUpsells();
    }
  });

  function init() {
    const drawer = document.querySelector(DRAWER);
    if (!drawer) return;

    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });

    if (drawer.classList.contains('active')) {
      randomizeUpsells();
      drawer.dataset.elyUpsellOpen = 'true';
      drawer._elyLastRail = drawer.querySelector(RAIL);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Upsell Add to Cart — Dawn section rendering.
  document.addEventListener('click', async function (event) {
    const button = event.target.closest('[data-ely-variant]');
    if (!button || button.disabled) return;

    event.preventDefault();

    const drawer = document.querySelector(DRAWER);
    if (!drawer || typeof drawer.renderContents !== 'function') return;

    button.disabled = true;

    const original = button.textContent;
    button.textContent = 'Adding...';

    try {
      const sections = drawer.getSectionsToRender()
        .map(section => section.id);

      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: Number(button.dataset.elyVariant),
          quantity: 1,
          sections: sections,
          sections_url: window.location.pathname
        })
      });

      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(result.description || 'Unable to add item');
      }

      drawer.renderContents(result);

    } catch (error) {
      alert(error.message || 'Please try again');
      button.disabled = false;
      button.textContent = original;
    }
  });

  // Upsell carousel next arrow.
  document.addEventListener('click', function (event) {
    const arrow = event.target.closest('.elysian-upsell-next');
    if (!arrow) return;

    const container = arrow.closest('.elysian-upsell');
    const track = container?.querySelector(RAIL);

    if (!track) return;

    const card = track.querySelector(
      '.ely-upsell__card:not([hidden])'
    );

    const distance = card
      ? card.getBoundingClientRect().width + 12
      : 200;

    track.scrollBy({
      left: distance,
      behavior: 'smooth'
    });
  });

})();
